import { useAdminVoucherHistoryPage } from "../../../Hooks/useAdminVoucherHistory";
import Styles from "./index.module.scss";
import clsx from "clsx";
import PaginationComponent from "../../../Share/Component/Pagination";
import TableComponent from "../../../Share/Component/Table";
import { VOUCHER_HISTORY_TABLE_COLUMNS } from "../../../Constants/voucher";
import { formatDate, formatNumber } from "../../../Utils";
function AdminVoucherHistory() {
  const { search, voucherHistories, paging, setSearch, getVoucherHistories } =
    useAdminVoucherHistoryPage();
  return (
    <div className={clsx(Styles.main, "flex-grow-1")}>
      <div className={clsx(Styles.bodyMain, "container-fluid my-1")}>
        <div className={clsx(Styles.bodyMainTop)}>
          <div className={clsx(Styles.filterWrap)}>
            <div className={clsx(Styles.searchWrap)}>
              <input
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                className={clsx(Styles.search)}
              />
              <span
                onClick={() => getVoucherHistories(0)}
                className={clsx(Styles.btnSearch)}
              >
                Search
              </span>
            </div>
          </div>
        </div>
        <div className={clsx(Styles.table)} id="style-3">
          <TableComponent
            data={voucherHistories}
            header={VOUCHER_HISTORY_TABLE_COLUMNS}
            customFormatters={{
              created_at: formatDate,
              transfer_amount: formatNumber,
              applied_amount: formatNumber,
            }}
          />
        </div>
        <div className={clsx(Styles.footer)}>
          <div className={clsx(Styles.footerWrap)}>
            <PaginationComponent
              page={paging}
              handleCallApi={getVoucherHistories}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default AdminVoucherHistory;
